export class Part {
    constructor({ id, url, endIndex, startIndex, maxChunkSize, lengthToRead, urlExpiration }) {
        this.uploadedBytes = 0;
        this.id = id;
        this.url = url;
        this.endIndex = endIndex;
        this.startIndex = startIndex;
        this.maxChunkSize = maxChunkSize;
        this.lengthToRead = lengthToRead;
        this.urlExpiration = urlExpiration;
    }
    hydrateCreatedPart({ id, url, endIndex, startIndex, maxChunkSize, lengthToRead, urlExpiration }) {
        this.id = id;
        this.url = url;
        this.endIndex = endIndex;
        this.startIndex = startIndex;
        this.maxChunkSize = maxChunkSize;
        this.lengthToRead = lengthToRead;
        this.urlExpiration = urlExpiration;
        return this;
    }
    hydrateUploadingPart({ uploadedBytes }) {
        this.uploadedBytes = uploadedBytes;
        return this;
    }
    hydrateUploadedPart({ part }) {
        this.crc32 = part.crc32;
        this.etag = part.etag;
        return this;
    }
    hydrateCompletedPart(part) {
        this.crc32 = part.crc32;
        this.etag = part.etag;
        return this;
    }
    reset() {
        this.url = undefined;
        this.endIndex = undefined;
        this.startIndex = undefined;
        this.maxChunkSize = undefined;
        this.lengthToRead = undefined;
        this.urlExpiration = undefined;
        this.uploadedBytes = 0;
        this.etag = undefined;
        this.crc32 = undefined;
    }
}
